import { action } from "typesafe-actions";

import { message } from "antd";

import {
  DateRangePayload,
  GatePayload,
  OrderingPayload,
  PaginatedResponse,
  PaginationPayload,
  ResolutionPayload,
} from "../common_types";

import {
  IntegrationErrorChartItem,
  IntegrationErrorItem,
  IntegrationErrorPayload,
  IntegrationErrorsActionTypes,
  IntegrationErrorsTypeSample,
} from "./types";

export const integrationErrorsFetchRequest = (
  payload: ResolutionPayload &
    DateRangePayload &
    GatePayload &
    PaginationPayload &
    OrderingPayload &
    IntegrationErrorPayload
) => action(IntegrationErrorsActionTypes.TABLE_FETCH_REQUEST, payload);

export const integrationErrorsFetchSuccess = (payload: PaginatedResponse<IntegrationErrorItem>) =>
  action(IntegrationErrorsActionTypes.TABLE_FETCH_SUCCESS, payload);

export const integrationErrorsFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(IntegrationErrorsActionTypes.TABLE_FETCH_ERROR);
};

export const integrationErrorsChartFetchRequest = (payload: ResolutionPayload & DateRangePayload & GatePayload) =>
  action(IntegrationErrorsActionTypes.CHART_FETCH_REQUEST, payload);

export const integrationErrorsChartFetchSuccess = (payload: IntegrationErrorChartItem[]) =>
  action(IntegrationErrorsActionTypes.CHART_FETCH_SUCCESS, payload);

export const integrationErrorsChartFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(IntegrationErrorsActionTypes.CHART_FETCH_ERROR);
};

export const integrationErrorsSamplesFetchRequest = (payload: GatePayload) =>
  action(IntegrationErrorsActionTypes.SAMPLES_FETCH_REQUEST, payload);

export const integrationErrorsSamplesFetchSuccess = (payload: IntegrationErrorsTypeSample) =>
  action(IntegrationErrorsActionTypes.SAMPLES_FETCH_SUCCESS, payload);

export const integrationErrorsSamplesFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(IntegrationErrorsActionTypes.SAMPLES_FETCH_ERROR);
};
